import { agentApiHeaders, apiBase, chatApiRequest } from '../agentApi'
import axios from '../axiosInstance'
import { ByoFormOption, ByoIntegration, ByoToolType, ChatApp, DynamicFormSchema } from './types'

/** Server-driven form schemas rendered by `byo-agents/forms/SchemaForm`. */

const aiAgentsGet = <T>(app: ChatApp, path: string): Promise<T> =>
  chatApiRequest<T>(() =>
    axios.get(`${apiBase(app)}/ai-agents/${path}`, { headers: agentApiHeaders(app) }),
  )

export const getAgentCreateForm = (app: ChatApp): Promise<DynamicFormSchema> =>
  aiAgentsGet<DynamicFormSchema>(app, 'forms/agent-creation')

export const getAgentEditForm = (app: ChatApp, uid: string): Promise<DynamicFormSchema> =>
  aiAgentsGet<DynamicFormSchema>(app, `forms/agent-edit/${encodeURIComponent(uid)}`)

export const getAgentIntegrations = (app: ChatApp): Promise<ByoIntegration[]> =>
  aiAgentsGet<ByoIntegration[]>(app, 'integrations')

// The create endpoints are plural (`actions-creation`), the edit endpoints singular.
export const getToolCreateForm = (app: ChatApp, type: ByoToolType): Promise<DynamicFormSchema> =>
  aiAgentsGet<DynamicFormSchema>(app, `forms/${type}s-creation`)

export const getToolEditForm = (
  app: ChatApp,
  type: ByoToolType,
  name: string,
): Promise<DynamicFormSchema> =>
  aiAgentsGet<DynamicFormSchema>(app, `forms/${type}-edit/${encodeURIComponent(name)}`)

/** Options for a `toggles` field, from its `dynamicOptions.apiEndPoints.url` (e.g. `ai-agents/forms/tools`). */
export const getFormOptions = (app: ChatApp, endpoint: string): Promise<ByoFormOption[]> =>
  chatApiRequest<ByoFormOption[]>(() =>
    axios.get(`${apiBase(app)}/${endpoint}`, { headers: agentApiHeaders(app) }),
  )

/** Sends a schema form to the endpoint and method its own `submitDetails` name. */
export const submitForm = (
  app: ChatApp,
  submitDetails: DynamicFormSchema['submitDetails'],
  payload: Record<string, unknown>,
): Promise<unknown> =>
  chatApiRequest<unknown>(() =>
    axios.request({
      url: `${apiBase(app)}/${submitDetails.url}`,
      method: submitDetails.method,
      data: payload,
      headers: agentApiHeaders(app),
    }),
  )
